<template>
  <div v-if="mGoods" class="page-goods-detail">
    <div class="title title-left title-label">
      <router-link :to="{name:'GoodsGroup',query:{id:mGoods.goods_class.id, group:groupName}}"
                   class="title-color">{{groupName}}</router-link>/{{mGoods.name}}
    </div>
    <div style="padding: 20px">
      <MyGoods :value="mGoods" detail
               :horizontal="!portrait"
               :btn-buy="$t('common.btn_buy')"
               :qrcode="$store.getters.inSoga"
               :buy-url="addOrderUrl"
               @on-detail="onViewImages"
               @on-buy="goOrderAdd"/>
    </div>
    <!-- 产品信息 -->
    <div class="title title-left title-label">{{$t('page.goods_detail.label_des')}}</div>
    <div class="goods-des"
         v-html="mGoods.content_mobile || mGoods.content"/>
    <div class="goods-des" v-if="mGoods.delivery_type||mGoods.notice||mGoods.refund_info"><hr/></div>
    <!-- 运送方式 -->
    <div v-if="mGoods.delivery_type" class="goods-des" v-html="mGoods.delivery_type"/>
    <!-- 注意事项 -->
    <div v-if="mGoods.notice" class="goods-des" v-html="mGoods.notice"/>
    <!-- 退换货规定 -->
    <div v-if="mGoods.refund_info" class="goods-des" v-html="mGoods.refund_info"/>
    <div v-if="!$route.query.soga_card">
      <div class="bottom-buttons">
        <Button long class="btn"
                @click.stop="$router.go(-1)">{{ $t('common.btn_back') }}
        </Button>
      </div>
    </div>
    <!-- 大图查看 -->
    <div v-if="mImageShow" class="image-viewer" @click.stop="mImageShow=false">
      <Swiper v-if="mGoods.images.length>1" v-model="mImageIndex"
              class="swiper" :options="viewOption" ref="mySwiper"
              :slides-per-view="3" :space-between="50">
        <SwiperSlide v-for="(item,index) in mGoods.images" :key="index"
                     class="swiper-item">
          <img class="goods-image" :onload="bigImageLoad" :src="item">
        </SwiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </Swiper>
      <img v-else class="goods-image"
           :onload="bigImageLoad" :src="mGoods.images[0]">
    </div>
  </div>
  <div v-else-if="!loading"
       class="no-content-tip">{{$t('goods.tip_no_exist')}}</div>
</template>
<script>
    import { httpGet, CancelToken, httpGetParams } from '@/api/http';
    import MyGoods from '@/components/MyGoodsNew';
    import 'swiper/css/swiper.css';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
    import common from '@/mixins/common';

    export default {
        components: {
            MyGoods,
            Swiper,
            SwiperSlide
        },
        mixins: [common],
        data () {
            return {
                portrait: false,
                loading: true,

                addOrderUrl: null,
                mTimer: null,

                mImageShow: false,
                mImageIndex: 0,

                mGoodsId: 0,
                mGoods: null,
                mPass: '',

                viewOption: {
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    // 显示分页
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true // 允许分页点击跳转
                    },
                    // 设置点击箭头
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
        },
        computed: {
            groupName () {
                let group = this.mGoods.goods_class;
                let value = '';
                while (group) {
                    if (value) {
                        value = '/' + value;
                    }
                    value = group.name + value;
                    group = group.parent;
                }
                // value += '/' + this.mGoods.name;
                return value;
            },
            bigImageLoad () {
                return 'const w = this.parentNode.clientWidth;const h = this.parentNode.clientHeight;' +
                    'if (w && h){const f=this.width/this.height;' +
                    'if(f > w/h){' +
                    'this.width=w;this.height=w/f;this.hspace=0;this.vspace=(h-this.height)>>1;' +
                    '}else{' +
                    'this.height=h;this.width=h*f;this.vspace=0;this.hspace=(w-this.width)>>1;}}';
            }
        },
        methods: {
            loadData () {
                this.loading = true;
                this.$Spin.show();

                if (this.cancel) {
                    this.cancel();
                    this.cancel = null;
                }
                const params = {}
                if (this.mPass !== '') {
                    params.pass = this.mPass
                }
                httpGetParams('/v1/goods/' + this.mGoodsId, params, new CancelToken((c) => {
                    this.cancel = c;
                })).then(res => {
                    if (res) {
                        this.mGoods = res;
                        // 修改title
                        const metaInfo = {
                            title: this.mGoods.name,
                            description: this.mGoods.subname,
                            ogTitle: this.mGoods.name,
                            ogDescription: this.mGoods.subname,
                            ogImage: this.mGoods.master_image
                        }
                        this.$store.commit('setMetaInfo', metaInfo);
                        if (this.$store.getters.inSoga) {
                            this.obtainLoginToken();
                        }
                    }
                }).catch(() => {
                }).finally(() => {
                    this.$Spin.hide();
                    this.loading = false;
                    this.cancel = null;
                });
            },
            obtainLoginToken () {
                httpGet('/v1/user/auto/code').then(res => {
                    let url = window.location.href;
                    const pos = url.indexOf('/', 10);
                    if (pos > 0) {
                        url = url.substring(0, pos);
                    }
                    // url = 'https://testmall.atlasai.tv';
                    // 生成下单地址
                    const token = res;
                    this.addOrderUrl = url +
                        this.$router.face.buildOrderUrl(token, this.mGoods.id, 1);
                    // console.error(this.addOrderUrl);
                }).catch(() => {
                    this.addOrderUrl = '';
                }).finally(() => {
                    const timeout = this.addOrderUrl ? 30000 : 10000;
                    // 启动定时器刷新token
                    this.mTimer = setTimeout(() => {
                        this.obtainLoginToken();
                    }, timeout);
                });
            },
            onViewImages (index) {
                this.mImageIndex = index;
                this.mImageShow = true;
                this.$nextTick(() => {
                    this.$refs.mySwiper.$swiper.slideTo(index + 1, 0)
                })
            },
            goOrderAdd () {
                if (this.$route.query.preview) {
                    return;
                }
                this.$router.face.order(this.mGoods).go();
            }
        },
        mounted () {
        },
        created () {
            if (this.$route.params.goods) {
                this.mGoods = this.$route.params.goods;
            } else {
                let id = this.$route.query.id;
                if (typeof id === 'string') {
                    id = parseInt(id);
                }
                if (typeof id !== 'number' || id <= 0) {
                    this.$router.back();
                    return;
                }
                this.mGoodsId = id;
                const p = this.$route.query.p;
                if (typeof p === 'string') {
                    this.mPass = p;
                }
            }
            if (window.screen.width < 730) {
                this.portrait = true;
            }
            this.loadData();
        },
        beforeDestroy () {
            if (!this.mTimer) {
                clearTimeout(this.mTimer);
                this.mTimer = null;
            }
            if (this.cancel) {
                this.cancel();
                this.cancel = null;
            }
        }
    }
</script>

<style lang="scss">
  .page-goods-detail {
    .goods-des {
      padding: 20px;
      img {
        vertical-align: bottom;
        //width: 100%;
        //height: auto;
      }
    }
    .image-viewer {
      z-index:100;
      background-color:black;
      width:100%;
      height:100%;
      text-align: center;
      position: fixed;
      left: 0;
      top:0;

      .btn-close {
        position: absolute;
        right: 0;
        top:0;
        z-index: 100;
      }

      .goods-image {
        vertical-align: bottom;
      }

      .swiper-item {
        text-align: center;
        padding: 0;
      }
      .swiper {
        width: 100%;
        height: 100%;
        vertical-align: middle;
      }
      .swiper-pagination-bullet {
        background-color: #eaeaea;
      }
      .swiper-button-prev:after, .swiper-button-next:after {
        font-size: 24px;
        color: #c6c6c6;
      }
    }
    .youtube-container {
      position: relative;
      /* padding-bottom: 56.25%; */
      /* 16:9 */
      text-align: center;
      margin: auto;
      width: 1200px;
      padding-bottom: 675px;
      height: 0;
    }

    @media screen and (max-width:1200px) {
      .youtube-container {
        width: 100%;
        padding-bottom: 56.25%;
      }
    }

    .youtube-container iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
